"use strict";

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmbeddedTransactionBuilder = void 0;

var GeneratorUtils_1 = require("./GeneratorUtils");

var PublicKeyDto_1 = require("./PublicKeyDto");

var EmbeddedTransactionBuilder = /*#__PURE__*/function () {
  function EmbeddedTransactionBuilder(signerPublicKey, version, network, type) {
    _classCallCheck(this, EmbeddedTransactionBuilder);

    GeneratorUtils_1.GeneratorUtils.notNull(signerPublicKey, 'signerPublicKey is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(version, 'version is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(network, 'network is null or undefined');
    GeneratorUtils_1.GeneratorUtils.notNull(type, 'type is null or undefined');
    this.signerPublicKey = signerPublicKey;
    this.version = version;
    this.network = network;
    this.type = type;
  }

  _createClass(EmbeddedTransactionBuilder, [{
    key: "getSignerPublicKey",
    value: function getSignerPublicKey() {
      return this.signerPublicKey;
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return this.version;
    }
  }, {
    key: "getNetwork",
    value: function getNetwork() {
      return this.network;
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var size = 0;
      size += 4;
      size += 4;
      size += this.signerPublicKey.getSize();
      size += 4;
      size += 1;
      size += 1;
      size += 2;
      return size;
    }
  }, {
    key: "getBody",
    value: function getBody() {
      return undefined;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var newArray = Uint8Array.from([]);
      var sizeBytes = GeneratorUtils_1.GeneratorUtils.uint32ToBuffer(this.getSize());
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, sizeBytes);
      var embeddedTransactionHeaderReserved1Bytes = GeneratorUtils_1.GeneratorUtils.uint32ToBuffer(0);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, embeddedTransactionHeaderReserved1Bytes);
      var signerPublicKeyBytes = this.signerPublicKey.serialize();
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, signerPublicKeyBytes);
      var entityBodyReserved1Bytes = GeneratorUtils_1.GeneratorUtils.uint32ToBuffer(0);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, entityBodyReserved1Bytes);
      var versionBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.getVersion());
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, versionBytes);
      var networkBytes = GeneratorUtils_1.GeneratorUtils.uint8ToBuffer(this.network);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, networkBytes);
      var typeBytes = GeneratorUtils_1.GeneratorUtils.uint16ToBuffer(this.type);
      newArray = GeneratorUtils_1.GeneratorUtils.concatTypedArrays(newArray, typeBytes);
      return newArray;
    }
  }], [{
    key: "loadFromBinary",
    value: function loadFromBinary(payload) {
      var byteArray = Array.from(payload);
      var size = GeneratorUtils_1.GeneratorUtils.bufferToUint32(Uint8Array.from(byteArray));
      byteArray.splice(0, 4);
      GeneratorUtils_1.GeneratorUtils.bufferToUint32(Uint8Array.from(byteArray));
      byteArray.splice(0, 4);
      var signerPublicKey = PublicKeyDto_1.PublicKeyDto.loadFromBinary(Uint8Array.from(byteArray));
      byteArray.splice(0, signerPublicKey.getSize());
      GeneratorUtils_1.GeneratorUtils.bufferToUint32(Uint8Array.from(byteArray));
      byteArray.splice(0, 4);
      var version = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var network = GeneratorUtils_1.GeneratorUtils.bufferToUint8(Uint8Array.from(byteArray));
      byteArray.splice(0, 1);
      var type = GeneratorUtils_1.GeneratorUtils.bufferToUint16(Uint8Array.from(byteArray));
      byteArray.splice(0, 2);
      return new EmbeddedTransactionBuilder(signerPublicKey, version, network, type);
    }
  }, {
    key: "createEmbeddedTransactionBuilder",
    value: function createEmbeddedTransactionBuilder(signerPublicKey, version, network, type) {
      return new EmbeddedTransactionBuilder(signerPublicKey, version, network, type);
    }
  }]);

  return EmbeddedTransactionBuilder;
}();

exports.EmbeddedTransactionBuilder = EmbeddedTransactionBuilder;